import { SelectedColumnsSetting } from './schemes/selectedColumnsSetting';
import { SmartlinksSelectedColumnsSetting } from './schemes/smartlinksSelectedColumnsSetting';
import { HeaderPrivateMode } from './schemes/headerPrivateMode';
import { Languages } from './schemes/languages';
import { ColumnsOrderSetting } from './schemes/columnsOrderSetting';
import { SummaryFormPresets } from './schemes/summaryFormPresets';
import { Dashboard } from './schemes/dashboard';
import { DashboardCalculator } from './schemes/dashboardCalculator';
import { VALIDATION_SCHEMAS } from './schemes';
import { ChartCollapsed } from './schemes/chartCollapsed';
import { SnowballEffect } from './schemes/snowballEffect';

export type UserSetting<T = string | null> = {
  name: string;
  value: T;
};

export type UserSettingsTypes =
  | SelectedColumnsSetting
  | SmartlinksSelectedColumnsSetting
  | HeaderPrivateMode
  | Languages
  | ColumnsOrderSetting
  | Dashboard
  | DashboardCalculator
  | SummaryFormPresets
  | ChartCollapsed
  | SnowballEffect;

export type GetUserSettingsServicePayload = {
  name: keyof typeof VALIDATION_SCHEMAS;
  format: 'json' | 'text';
};

export type RequestPromiseProps = Pick<
  PromiseConstructor,
  'resolve' | 'reject'
>;

export enum UserSettings {
  HeaderPrivateMode = 'headerPrivateMode',
  SelectedColumnsSetting = 'selectedColumnsSetting',
  Languages = 'languages',
  ColumnsOrderSetting = 'columnsOrderSetting',
  SmartlinksSelectedColumnsSetting = 'smartlinksSelectedColumnsSetting',
  SummaryFormPresets = 'summaryFormPresets',
  DashboardCalculator = 'dashboardCalculator',
  Dashboard = 'dashboard',
  DashboardProject = 'dashboardProject',
  ChartCollapsed = 'chartCollapsed',
  SnowballEffect = 'snowballEffect',
}
